/**
 * @voltxampere/ui — RF mixer placeholder (Sprint 45-3, placeholder)
 *
 * PLACEHOLDER. Generic RF mixer — gerçek RF down-conversion (LO ×
 * RF = IF + image) Sprint 47+ engine extension #4 ile (multiplier
 * stamp). Şu anki davranış canonical `bjt-npn` placeholder (single
 * transistor mixer pattern, Gilbert cell yok).
 *
 * Reference: Generic double-balanced mixer (e.g. Mini-Circuits SBL-1,
 * SAY-1, Analog Devices ADL5350). LO_freq input, RF_freq input,
 * IF_freq output (= |LO ± RF|). Heterodyne receiver (FM/AM tuner,
 * superheterodyne radio, SDR front-end downconverter). Conversion
 * loss 5-7 dB typical, IIP3 +20 dBm.
 *
 *   Default mapping → bjt-npn schemaType:
 *     Is = 1e-14, Bf = 100, Vaf = 50  (placeholder values)
 *
 * Engine zero-diff invariant honored — canonical `bjt-npn` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const rfMixer = {
    id: "rf-mixer",
    nameTr: "RF Mixer (DBM, placeholder)",
    nameEn: "RF Mixer (DBM, placeholder)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "MIXER",
    schemaType: "bjt-npn",
    defaultParams: { Is: 1e-14, Bf: 100, Vaf: 50 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=rf-mixer.js.map